<div class="modal-header">
    <h4 class="modal-title">Nuevo Grupo de Preguntas</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="modal-body">
    <form [formGroup]="createForm" (ngSubmit)="save()">
        <div class="row g-2">
            <div class="col-12 col-md-8">
                <label class="form-label">Título *</label>
                <input type="text" class="form-control form-control-sm" formControlName="title"
                    placeholder="Ej: Preguntas de salud" />
            </div>
            <div class="col-12 col-md-4">
                <label class="form-label">Fase *</label>
                <select class="form-select form-select-sm" formControlName="phase">
                    <option *ngFor="let opt of phaseOptions" [value]="opt.value">{{ opt.label }}</option>
                </select>
            </div>
            <div class="col-12">
                <label class="form-label">Descripción</label>
                <textarea class="form-control form-control-sm" formControlName="description" rows="2"
                    placeholder="Descripción opcional del grupo"></textarea>
            </div>
        </div>

        <!-- Questions Section -->
        <div class="mt-3 pt-3 border-top">
            <div class="mb-2">
                <label class="form-label mb-0 fw-medium">Preguntas</label>
                <div *ngIf="questionsToCreate.length > 1" class="form-text mt-0">
                    Arrastra las preguntas o usa las flechas para cambiar el orden en que se muestran.
                </div>
            </div>

            <div *ngIf="questionsToCreate.length === 0" class="text-muted small fst-italic mb-3">
                No hay preguntas. Haga clic en el botón de abajo para comenzar.
            </div>

            <div cdkDropList (cdkDropListDropped)="drop($event)" class="question-list">
            <div *ngFor="let question of questionsToCreate; let i = index" cdkDrag
                class="card mb-3 border-secondary-subtle question-card">
                <div class="card-body p-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <div class="d-flex align-items-center gap-1">
                            <span cdkDragHandle class="material-symbols-outlined text-muted fs-5 drag-handle"
                                title="Arrastrar para reordenar">drag_indicator</span>
                            <h6 class="card-subtitle mb-0 text-muted small fw-bold">Pregunta {{i + 1}}</h6>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                            <button type="button" class="btn btn-sm text-secondary p-0" (click)="moveQuestion(i, -1)"
                                [disabled]="i === 0" title="Subir pregunta" aria-label="Subir pregunta">
                                <span class="material-symbols-outlined fs-5">arrow_upward</span>
                            </button>
                            <button type="button" class="btn btn-sm text-secondary p-0" (click)="moveQuestion(i, 1)"
                                [disabled]="i === questionsToCreate.length - 1" title="Bajar pregunta"
                                aria-label="Bajar pregunta">
                                <span class="material-symbols-outlined fs-5">arrow_downward</span>
                            </button>
                            <button type="button" class="btn btn-sm text-danger p-0" (click)="removeQuestion(i)"
                                title="Eliminar pregunta">
                                <span class="material-symbols-outlined fs-5">delete</span>
                            </button>
                        </div>
                    </div>

                    <div class="row g-3">
                        <!-- Type -->
                        <div class="col-md-5">
                            <label class="form-label small text-muted mb-1">Tipo *</label>
                            <select class="form-select form-select-sm" [ngModel]="question.type"
                                (ngModelChange)="updateQuestion(i, 'type', $event)"
                                [ngModelOptions]="{standalone: true}">
                                <option *ngFor="let opt of questionTypeOptions" [ngValue]="opt.value">
                                    {{ opt.label }}
                                </option>
                            </select>
                        </div>

                        <!-- Required Checkbox -->
                        <div class="col-md-2 d-flex align-items-end mb-1">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" [id]="'required-' + i"
                                    [ngModel]="question.isRequired"
                                    (ngModelChange)="updateQuestion(i, 'isRequired', $event)"
                                    [ngModelOptions]="{standalone: true}">
                                <label class="form-check-label small" [for]="'required-' + i">Requerida</label>
                            </div>
                        </div>

                        <!-- Cancel Value (if Selection phase) -->
                        <div class="col-md-5" *ngIf="createForm.value.phase === 'Selection'">
                            <label class="form-label small text-muted mb-1">Valor de Rechazo</label>
                            <ng-container [ngSwitch]="question.type">
                                <!-- Bool: Select Yes/No -->
                                <select *ngSwitchCase="QuestionType.Bool" class="form-select form-select-sm"
                                    [ngModel]="question.cancelOnValue"
                                    (ngModelChange)="updateQuestion(i, 'cancelOnValue', $event)"
                                    [ngModelOptions]="{standalone: true}">
                                    <option value="" disabled selected>Seleccione...</option>
                                    <option value="true">Sí</option>
                                    <option value="false">No</option>
                                </select>

                                <!-- File: Select Uploaded/Not Uploaded -->
                                <select *ngSwitchCase="QuestionType.File" class="form-select form-select-sm"
                                    [ngModel]="question.cancelOnValue"
                                    (ngModelChange)="updateQuestion(i, 'cancelOnValue', $event)"
                                    [ngModelOptions]="{standalone: true}">
                                    <option value="" disabled selected>Seleccione...</option>
                                    <option value="false">No Subido</option>
                                    <option value="true">Subido</option>
                                </select>

                                <!-- Default: Text Input -->
                                <input *ngSwitchDefault type="text" class="form-control form-control-sm"
                                    [ngModel]="question.cancelOnValue"
                                    (ngModelChange)="updateQuestion(i, 'cancelOnValue', $event)"
                                    [ngModelOptions]="{standalone: true}" placeholder="Valor rechazo" />
                            </ng-container>
                        </div>

                        <!-- Title -->
                        <div class="col-12">
                            <label class="form-label small text-muted mb-1">Título *</label>
                            <input type="text" class="form-control form-control-sm" [ngModel]="question.title"
                                (ngModelChange)="updateQuestion(i, 'title', $event)"
                                [ngModelOptions]="{standalone: true}" placeholder="Título de la pregunta" />
                        </div>

                        <!-- Description -->
                        <div class="col-12">
                            <label class="form-label small text-muted mb-1">Descripción (Opcional)</label>
                            <textarea class="form-control form-control-sm" rows="2" [ngModel]="question.description"
                                (ngModelChange)="updateQuestion(i, 'description', $event)"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="Descripción de la pregunta"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            </div>

            <div class="mt-2 mb-4">
                <button type="button" class="btn btn-outline-secondary w-100 py-2 border-dashed"
                    (click)="addQuestion()">
                    <span class="material-symbols-outlined align-middle me-1">add</span>
                    Agregar pregunta
                </button>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="dismiss()">Cancelar</button>
    <button type="button" class="btn btn-colonial" (click)="save()" [disabled]="createForm.invalid || loading">
        Guardar
    </button>
</div>